import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { initSentry } from "./utils/sentry";

// Global error handling for browser extension and network errors
window.addEventListener('error', (event) => {
  // Suppress common browser extension and ad blocker errors
  if (event.message.includes('ERR_BLOCKED_BY_CLIENT') ||
      event.message.includes('The message port closed before a response was received') ||
      event.message.includes('runtime.lastError')) {
    event.preventDefault();
    return false;
  }
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && typeof event.reason === 'string' &&
      (event.reason.includes('ERR_BLOCKED_BY_CLIENT') ||
       event.reason.includes('NetworkError') ||
       event.reason.includes('Failed to fetch'))) {
    event.preventDefault();
    return false;
  }
});

initSentry();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
